import yamamoto from "./yamamoto.jpg"
import nishigori from "./nishigori.jpeg"
import zhao from "./zhao.png"
import omiya from "./omiya.jpeg"
import he from "./he.png"
import yokoyama from "./yokoyama.jpeg"
import ando from "./ando.jpeg"
import yamada from "./yamada.png"
import lakshan from "./lakshan.png"
import sookplang from "./sookplang.jpeg"
import tanaka from "./tanaka.jpeg"
import maeda from "./maeda.jpeg"
import shimoide from "./shimoide.jpeg"
import yasui from "./yasui.jpeg"
import sakamoto from "./sakamoto.jpeg"
import hotta from "./hotta.jpeg"
import takamatsu from "./takamatsu.jpeg"
import fukuda from "./fukuda.jpeg"
import doi from "./doi.jpeg"
import marui from "./marui.jpeg"
import yanagi from "./yanagi.jpeg"

const volunteers ={
    "Website": [
        {
            name: 'Victor Eiti Yamamoto',
            img: yamamoto,
            institution: 'National Institute of Informatics / The Graduate University for Advanced Studies, SOKENDAI',
            country: 'Japan',
        }
    ],
    "Whova": [
        {
            name: 'Victor Eiti Yamamoto',
            img: yamamoto,
            institution: 'National Institute of Informatics / The Graduate University for Advanced Studies, SOKENDAI',
            country: 'Japan',
        },
        {
            name: 'Kotaro Nishigori',
            img: nishigori,
            institution: 'National Institute of Informatics / The Graduate University for Advanced Studies, SOKENDAI',
            country: 'Japan',
        },
    ],
    "On-site Staff": [
        {
            name: "Shixiong ZHAO",
            img: zhao,
            institution: 'National Institute of Informatics / The Graduate University for Advanced Studies, SOKENDAI',
            country: 'Japan',
        },
        {
            name: "Takeshi Omiya",
            img: omiya,
            institution: "University of Tokyo",
            country: 'Japan',
        },
        {
            name: "Yanming He",
            img: he,
            institution: 'National Institute of Informatics / The Graduate University for Advanced Studies, SOKENDAI',
            country: 'Japan',
        },
        {
            name: "Haruki Yokoyama",
            img: yokoyama,
            institution: 'The University of Electro-Communications',
            country: 'Japan',
        },
        {
            name: "Taichi Ando",
            img: ando,
            institution: 'The University of Electro-Communications',
            country: 'Japan',
        },
        {
            name: "Shintaro Yamada",
            img: yamada,
            institution: 'University of Tokyo',
            country: 'Japan',
        },
        {
            name: 'Kotaro Nishigori',
            img: nishigori,
            institution: 'National Institute of Informatics / The Graduate University for Advanced Studies, SOKENDAI',
            country: 'Japan',
        },
        {
            name: 'Lakshan Karunathilake',
            img: lakshan,
            institution: 'National Institute of Informatics / The Graduate University for Advanced Studies, SOKENDAI',
            country: 'Japan',
        },
        {
            name: 'Sookplang Vidchaphol',
            img: sookplang,
            institution: 'Japan Advanced Institute of Science and Technology',
            country: 'Japan',
        },
        {
            name: 'Atsumi Tanka',
            img: tanaka,
            institution: 'Osaka Electro-Communication University',
            country: 'Japan',
        },
        {
            name: 'Ryo Maeda',
            img: maeda,
            institution: 'Osaka Electro-Communication University',
            country: 'Japan',
        },
        {
            name: 'Ren Shimoide',
            img: shimoide,
            institution: 'Osaka Electro-Communication University',
            country: 'Japan',
        },
        {
            name: 'Masahito Yasui',
            img: yasui,
            institution: 'Osaka Electro-Communication University',
            country: 'Japan',
        },
        {
            name: 'Takumi Sakamoto',
            img: sakamoto,
            institution: 'Osaka Electro-Communication University',
            country: 'Japan',
        },
        {
            name: 'Takehiro Hotta',
            img: hotta,
            institution: 'Osaka Electro-Communication University',
            country: 'Japan',
        },
        {
            name: 'Yuya Takamatsu',
            img: takamatsu,
            institution: 'Osaka Electro-Communication University',
            country: 'Japan',
        },
        {
            name: 'Shintaro Fukuda',
            img: fukuda,
            institution: 'Osaka Electro-Communication University',
            country: 'Japan',
        },
        {
            name: 'Kohei Doi',
            img: doi,
            institution: 'Osaka Electro-Communication University',
            country: 'Japan',
        },
        {
            name: 'Yui Marui',
            img: marui,
            institution: 'University of Hyogo',
            country: 'Japan',
        },
        {
            name: 'Yui Yanagi',
            img: yanagi,
            institution: 'University of Hyogo',
            country: 'Japan',
        },
    ]
};

export default volunteers;